var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLookAroundMobile = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 51,
    viewBox: "0 0 38 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.311 1v15.244m0-15.244-2.178 2.178M29.311 1l2.178 2.178M29.31 16.244l-2.178-2.177m2.178 2.177 2.178-2.177m5.444-5.445H21.69m15.244 0-2.177-2.178m2.177 2.178L34.756 10.8M21.689 8.622l2.178-2.178m-2.178 2.178 2.178 2.178M7.533 22.778a3.266 3.266 0 1 0-6.533 0v10.889C1 42.687 8.313 50 17.333 50s16.334-7.313 16.334-16.333v-8.711a3.267 3.267 0 1 0-6.534 0v-2.178a3.266 3.266 0 1 0-6.533 0V20.6a3.267 3.267 0 1 0-6.533 0V5.356a3.266 3.266 0 1 0-6.534 0V30.4v-7.622Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgLookAroundMobile as ReactComponent };